var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLicenseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 5.33334V8.66668L10.1667 10.3467L10.68 9.49334L8.33334 8.10001V5.33334H7.33334ZM14 6.66668V2.00001L12.24 3.76001C11.6847 3.20092 11.024 2.75749 10.2963 2.45539C9.56847 2.15329 8.788 1.99851 8 2.00001C6.81331 2.00001 5.65328 2.3519 4.66658 3.01119C3.67989 3.67048 2.91085 4.60755 2.45673 5.70391C2.0026 6.80027 1.88378 8.00667 2.11529 9.17055C2.3468 10.3344 2.91825 11.4035 3.75736 12.2427C4.59648 13.0818 5.66558 13.6532 6.82946 13.8847C7.99335 14.1162 9.19975 13.9974 10.2961 13.5433C11.3925 13.0892 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.1867 14 8.00001H12.6667C12.6667 10.5733 10.5733 12.6667 8 12.6667C5.42667 12.6667 3.33334 10.5733 3.33334 8.00001C3.33334 5.42668 5.42667 3.33334 8 3.33334C9.28667 3.33334 10.4533 3.86001 11.3 4.70001L9.33334 6.66668H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLicenseIcon);
export default __webpack_public_path__ + "static/media/change_license_icon.2b79abcc9c63a1f20f80456f13d04fae.svg";
export { ForwardRef as ReactComponent };